{
  "page": {
    "tagline":  "Başarı Hikayeleri",
    "title":    "Küresel Vizyon,",
    "titleAccent": "Somut Sonuçlar.",
    "subtitle": "GlobalAnka olarak sunduğumuz stratejik iş gücü çözümleriyle sektör liderlerinin büyüme yolculuklarına eşlik ediyoruz. İşte dönüşüm hikayelerimiz."
  },
  "filter": {
    "label": "Sektör Filtresi",
    "all":   "Tümü"
  },
  "card": {
    "problem":  "Problem",
    "solution": "Çözüm",
    "result":   "Sonuç",
    "viewCase": "Vaka Detaylarını İncele",
    "backToList": "Tüm Referanslara Dön",
    "imageLayout": "vertical"
  },
  "stats": {
    "rows": [
      { "label": "Tamamlanan Proje", "value": "500+" },
      { "label": "Aktif Personel", "value": "12.5k" },
      { "label": "Operasyonel Destek", "value": "24/7" },
      { "label": "Hizmet Verilen Ülke", "value": "15+" }
    ]
  },
  "cta": {
    "title": "Sizin Başarı Hikayenizi Birlikte Yazalım",
    "buttons": [
      { "label": "Stratejik Danışmanlık Alın", "href": "/contact", "variant": "gold" },
      { "label": "Hizmetlerimizi İnceleyin", "href": "/portfolio", "variant": "outline" }
    ]
  },
  "sectors": {
    "tourism":      "Turizm & Konaklama",
    "construction": "Endüstriyel Üretim",
    "health":       "Sağlık",
    "logistics":    "Lojistik & Dağıtım",
    "technology":   "Teknoloji & Fintech"
  },
  "detail": {
    "challenge": "Zorluk",
    "solution":  "Çözüm",
    "result":    "Sonuç",
    "year":      "Yıl",
    "client":    "Müşteri",
    "sector":    "Sektör"
  },
  "labels": {
    "challenge": "Zorluk",
    "solution":  "Çözüm",
    "result":    "Sonuç"
  },
  "items": {
    "1": {
      "title": "Uluslararası Resort Zinciri Operasyonel Dönüşümü",
      "client": "Gizli Tutuluyor",
      "summary":   "Yüzlerce çok dilli profesyonelin 3 hafta içinde sahaya entegrasyonuyla misafir memnuniyetinde %24 artış.",
      "challenge": "Akdeniz bölgesinin en büyük resort zincirlerinden biri, yüksek sezonda yaşadığı kalifiye personel açığı nedeniyle misafir memnuniyet puanlarında kritik bir düşüş yaşıyordu. Yönetim; önbüro, F&B ve animasyon departmanlarında 150'nin üzerinde çok dilli ve deneyimli profesyonele, sezon başından yalnızca 3 hafta önce ihtiyaç duyduğunu bildirdi.",
      "solution":  "GlobalAnka \"Elite Crew\" programı devreye alındı. 12 ülkeden, ortalama 5 yıl otelcilik deneyimine sahip adaylar, dijital mülakat süreci ile 72 saat içinde seçildi. Gerekli yasal belgeler ve KVKK uyumlu sözleşmeler paralel olarak tamamlandı; ekipler yerinde eğitim ve oryantasyon programıyla sahaya entegre edildi.",
      "result":    "Sezon boyunca misafir memnuniyet skoru %24 artarak zincirin tarihsel en yüksek değerine ulaştı. Personel devir hızı sektör ortalamasının %60 altında seyretti. İşveren, takip eden sezon için kapasiteyi %30 artırma kararı aldı.",
      "metrics": [
        { "label": "Memnuniyet Artışı", "value": "+%24" },
        { "label": "Yerleştirilen Personel", "value": "150+" },
        { "label": "Süre", "value": "3 Hafta" }
      ]
    },
    "2": {
      "title": "Kapadokya Butik Otel Zinciri İK Dönüşümü",
      "client": "Gizli Tutuluyor",
      "summary":   "Beş yıldızlı butik oteller için sadece 45 günde sürdürülebilir İK altyapısı ve %98 sözleşme uyumu.",
      "challenge": "UNESCO Dünya Mirası bölgesinde faaliyet gösteren 4 butik otellik bir zincir, uluslararası misafir profiline karşın İngilizce yetkin personel bulmakta zorlanıyordu. Ek olarak, mevsimlik çalışma modeli; İş Kanunu ve İŞKUR düzenlemeleri açısından önemli uyumluluk riskleri taşıyordu.",
      "solution":  "GlobalAnka, turizm hukuku uzmanları eşliğinde önce mevcut sözleşme altyapısını denetledi ve 100 sözleşmenin tamamını revize etti. Ardından yurt içi ve yurt dışı kaynaklardan toplam 38 çok dilli uzman transfer edildi. Her aday için birebir kültürel uyum değerlendirmesi yapıldı.",
      "result":    "TripAdvisor ve Google Review puanları 6 ay içinde 0.4 puan yüksseldi. Yasal uyumsuzluktan kaynaklanan ceza riski sıfıra indirildi. Tüm mevsimlik sözleşmeler hatasız yönetildi.",
      "metrics": [
        { "label": "Sözleşme Uyumu", "value": "%98" },
        { "label": "Review Artışı", "value": "+0.4 Puan" },
        { "label": "Yasal Risk", "value": "Sıfır" }
      ]
    },
    "3": {
      "title": "Otomotiv Yan Sanayi Teknik İş Gücü Optimizasyonu",
      "client": "Gizli Tutuluyor",
      "summary":   "Sertifikalı teknik kadro kiralama modeliyle eğitim maliyetini %40 düşürdük, üretim verimliliğini %22 artırdık.",
      "challenge": "Bursa'da faaliyet gösteren bir otomotiv yan sanayi firması, yüksek personel devir hızı ve teknik eğitim maliyetlerinin sürdürülemez boyutlara ulaştığını tespit etti. CNC operatörü ve kaynak ustası pozisyonlarında ortalama aylık devir oranı %18 seviyesindeydi.",
      "solution":  "GlobalAnka Akademi iş birliğiyle sertifikalı teknik kadro kiralama modeli tasarlandı. Adaylar işe alınmadan önce 3 haftalık GlobalAnka Akademi programından geçirildi; başarılı adaylar \"hazır yetkinlik\" belgesiyle müşteri tesisine entegre edildi.",
      "result":    "Aylık devir oranı 6 ay içinde %18'den %6'ya geriledi. Teknik eğitim harcamaları yıllık bazda %40 düştü. Üretim verimliliği ise planlanan hedefin %22 üzerinde gerçekleşti.",
      "metrics": [
        { "label": "Eğitim Maliyeti", "value": "-%40" },
        { "label": "Verimlilik Artışı", "value": "+%22" },
        { "label": "Devir Oranı Düşüşü", "value": "18% \u2192 6%" }
      ]
    },
    "4": {
      "title": "Mega İnşaat Projesi Uluslararası İş Gücü Yönetimi",
      "client": "Gizli Tutuluyor",
      "summary":   "8 ülkeden 600+ işçi, sıfır yasal uyumsuzluk ve planlanan sürenin 3 ay önünde proje teslimi.",
      "challenge": "Türkiye'nin en büyük altyapı projelerinden birinde çalışan müteaħit firma, 18 aylık süreçte 600'ün üzerinde yabancı uyruklu teknik işçiye ihtiyaç duydu. Çalışma izinleri, vize süreçleri ve çok uluslu sosyal güvenlik anlaşmaları firmayı hukuki açıdan ciddi riske sokuyordu.",
      "solution":  "GlobalAnka hukuk ekibi, 8 farklı ülkenin iş ve göç mevzuatını eşzamanlı yönetti. Çalışma izni başvuruları toplu ve öncelikli kanallar üzerinden işleme konuldu.",
      "result":    "Proje süresince tek bir yasal uyumsuzluk vakası yaşanmadı. Proje, planlanan bitiş tarihinin 3 ay öncesinde teslim edildi.",
      "metrics": [
        { "label": "Yönetilen İşçi", "value": "600+" },
        { "label": "Ülke Sayısı", "value": "8" },
        { "label": "Erken Teslim", "value": "3 Ay" }
      ]
    },
    "5": {
      "title": "Özel Hastane Zinciri Sağlık Personeli Temini",
      "client": "Gizli Tutuluyor",
      "summary":   "Doktor açığını 90 günde kapatarak hasta başvuru kapasitesini %35 artırdık.",
      "challenge": "Anadolu'da 7 şubesi bulunan özel bir hastane zinciri, uzman hekim yetersizliği nedeniyle poliklinik kapasitesinin %40 altında çalışıyordu. Kardiyoloji, ortopedi ve dahiliye uzmanı bulunması aylarca sürüyor, hasta bekleme listelerini kritik boyutlara taşıyordu.",
      "solution":  "GlobalAnka Sağlık bölümü, Türkiye, Azerbaycan ve Romanya'daki uzman hekim ağını devreye aldı. Her adayın Türkiye'de diploma denklik süreci ve SGK kayıt işlemleri uçtan uca yönetildi.",
      "result":    "Üç ay içinde 12 uzman hekim yerleştirildi; hastane kapasitesi hedeflenen düzeyin %35 üzerine çıktı. Hasta memnuniyet anketlerinde \"bekleme süresi\" skoru 3.1'den 4.6'ya yüksseldi.",
      "metrics": [
        { "label": "Kapasite Artışı", "value": "+%35" },
        { "label": "Yerleştirilen Uzman", "value": "12 Hekim" },
        { "label": "Tamamlama Süresi", "value": "90 Gün" }
      ]
    },
    "6": {
      "title": "Sağlık Turizmi Uluslararası Koordinasyon Merkezi",
      "client": "Gizli Tutuluyor",
      "summary":   "6 dilde hizmet veren koordinasyon ekibiyle uluslararası hasta sayısını yılda %60 artırdı.",
      "challenge": "İstanbul'da faaliyet gösteren bir sağlık turizmi şirketi, Orta Doğu ve Orta Asya'dan gelen hastalara yönelik koordinasyon süreçlerinde kritik iletişim kopuklukları yaşıyordu. Terümanlık eksikliği ve randevu koordinasyonundaki gecikmeler ciddi hasta kayıplarına yol açıyordu.",
      "solution":  "GlobalAnka, 6 dilde (Türkçe, Arapça, Rusça, Kazakça, İngilizce, Farsça) hizmet verebilen 14 kişilik koordinasyon ekibi kurdu. Yanıt süreleri ortalama 4 saatten 22 dakikaya indirildi.",
      "result":    "Uluslararası hasta sayısı 12 ay içinde %60 arttı. Hasta referans oranı %42'den %71'e çıktı.",
      "metrics": [
        { "label": "Hasta Artışı", "value": "+%60" },
        { "label": "Yanıt Süresi", "value": "4h \u2192 22dk" },
        { "label": "Referans Oranı", "value": "%42 \u2192 %71" }
      ]
    }
  }
}
